import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import { h5PageCount, wapactPageCount } from '../../../../../utils';
import { formatPlayNum } from '../../utils/playNumUnit';
import { getTopicData, getSurveyInfo } from '../../utils/api';
import { formatTime } from '../../utils/formatTime';
import {getSession} from '../../../../../base/base/storage';
import Grounds from '../../../../../base/grounds';

const { callApp } = require('@ifeng-fe/callapp');

// 单标题
class Sticky extends PureComponent {
    static propTypes = {
        item: PropTypes.object,
        url: PropTypes.string,
        countMapCache: PropTypes.object,
        isDisplaySource: PropTypes.bool,
        isNewsTime: PropTypes.bool,
        isFormatTime: PropTypes.bool,
        isCount: PropTypes.bool,
    };

    static defaultProps = {
        isDisplaySource: true,
        isNewsTime: false,
        isFormatTime: false,
        isCount: true,
        isClickListItem: false,
    };

    state = {
        topicCount: 0,
        topicUrl: '',
        surveyCount: 0,
    };

    ref = React.createRef();

    async componentDidMount() {
        const {
            index,
            item,
            item: { type },
            observer,
        } = this.props;
        const url = item['_url'] || item.url;

        this.ref.current.setAttribute('data-index', index);

        observer.observe(this.ref.current);

        if (type === 'theme') {
            try {
                const topicData = await getTopicData(url);

                this.setState({
                    topicCount: topicData.nnum && topicData.nnum.join,
                    topicUrl: topicData.shareurl,
                });
            } catch (e) {
                console.error(e);
            }
        }

        if (type === 'survey') {
            try {
                const surveyData = await getSurveyInfo(url);

                this.setState({
                    surveyCount: surveyData.surveyinfo && surveyData.surveyinfo.pnum,
                });
            } catch (e) {
                console.error(e);
            }
        }
    }

    handleClick = (url, id, newstype, kind, downloads, clickCountConfig) => {
        const doc_type = newstype;
        const aid = id;
        const {
            item: { isVideoShare, noPrefixKind = false },
        } = this.props;
        const client = isVideoShare ? 'videoApp' : 'newsApp';

        this.feedClickCountFn(clickCountConfig);

        callApp({
            client,
            docType: doc_type,
            pid: aid,
            kind,
            download: downloads && downloads.download,
            downloadAd: downloads && downloads.downloadAd,
            noKindFrom: noPrefixKind,
        });
    };

    feedClickCountFn = (config) => {
        if (window.grounds) return Grounds.jumpInNative(this.props.item);

        if (config) {
            h5PageCount([config]);
        }
    };

    handleCallup = (url, id, newstype, kind, downloads = {}, clickCountConfig, wapactCountConfig) => {
        const { item } = this.props;
        const { secretCallUp, noPrefixKind, isVideoShare } = item;
        const doc_type = newstype;
        const aid = id;
        const client = isVideoShare ? 'videoApp' : 'newsApp';

        if (secretCallUp && !getSession('secretCallSign')) {
            this.feedWapactCountFn(wapactCountConfig);

            callApp({
                client,
                docType: doc_type,
                pid: aid,
                kind,
                isSecretCall: secretCallUp,
                secretGoUrl: url,
                noKindFrom: noPrefixKind,
                download: downloads && downloads.download,
                downloadAd: downloads && downloads.downloadAd,
            });
        }
    };

    feedWapactCountFn = (config) => {
        if (config) {
            wapactPageCount(config);
        }
    };

    render() {
        const { topicCount, topicUrl, surveyCount } = this.state;
        let { url } = this.props;
        const { item, countMapCache, isDisplaySource, isNewsTime, isFormatTime, isCount } = this.props;
        let {
            title,
            source,
            id,
            _id,
            base62Id,
            commentUrl,
            type,
            newsTime,
            callUp,
            linkMark,
            newstype,
            clickCount,
            wapactCount,
            kind,
            stick,
            noStickText,
            downloads,
            articleTag,
            articleTagColor,
            hasBottomLine,
        } = item;
        const isSource = isDisplaySource && source && source !== '';
        const date = isFormatTime ? formatTime(newsTime) : newsTime;
        const clickCountConfig = clickCount ? clickCount : '';
        const wapactCountConfig = wapactCount ? wapactCount : '';

        let count = (countMapCache && countMapCache[commentUrl]) || 0;

        id = _id || id;
        url = topicUrl || url;
        if (typeof window === 'object' && window.grounds) url = null;

        if (type === 'theme') {
            count = topicCount;
        } else if (type === 'survey') {
            count = surveyCount;
        }

        let tagColorStyle = {};

        if (stick) {
            tagColorStyle = { color: '#f54343' };
        } else if (articleTagColor) {
            switch (articleTagColor) {
                case 7:
                    tagColorStyle = { color: '#3091f5' };
                    break;
                case 8:
                    tagColorStyle = { color: '#ff7900' };
                    break;
                case 9:
                    tagColorStyle = { color: '#4bc259' };
                    break;
                case 10:
                    tagColorStyle = { color: '#f54343' };
                    break;
            }
        }

        let tag = '';

        if (type === 'topic') {
            tag = <span className={styles.topicLink} />;
        } else if (type === 'theme') {
            tag = <span className={styles.themeLink} />;
        }

        return (
            <div
                className={`${styles.singleTitle} ${hasBottomLine ? styles.bottomLine : ''}`}
                ref={this.ref}
                onClick={this.handleCallup.bind(
                    this,
                    url,
                    id,
                    newstype,
                    kind,
                    downloads,
                    clickCountConfig,
                    wapactCountConfig,
                )}>
                <div className={stick ? styles.stickLink : styles.link}>
                    {callUp === 1 ? (
                        <a onClick={this.handleClick.bind(this, url, id, newstype, kind, downloads, clickCountConfig)}>
                            {tag}
                            {title}
                        </a>
                    ) : (
                        <a href={url} onClick={this.feedClickCountFn.bind(this, clickCountConfig)}>
                            {tag}
                            {title}
                        </a>
                    )}
                </div>
                <div className={styles.info}>
                    {callUp === 1 ? (
                        <div>
                            <span
                                onClick={this.handleClick.bind(
                                    this,
                                    url,
                                    id,
                                    newstype,
                                    kind,
                                    downloads,
                                    clickCountConfig,
                                )}
                                className={styles.openApp}>
                                打开APP阅读
                            </span>
                            {linkMark && (
                                <a onClick={this.feedClickCountFn.bind(this, clickCountConfig)} href={url}>
                                    <span className={styles.wap}>网页阅读</span>
                                </a>
                            )}
                            <span className={styles.count}>
                                {count && count !== 0 ? `${formatPlayNum(count)}评` : ''}
                            </span>
                        </div>
                    ) : (
                        <div>
                            {stick &&
                            !noStickText &&
                            !articleTag &&
                            type !== 'live' &&
                            type.indexOf('topic') === -1 && (
                                <span style={tagColorStyle} className={styles.stickMark}>
                                    置顶
                                </span>
                            )}
                            {articleTag && (
                                <span style={tagColorStyle} className={styles.stickMark}>
                                    {articleTag}
                                </span>
                            )}
                            {stick && type === 'live' && (
                                <span style={tagColorStyle} className={styles.stickLiveMark}>
                                    直播中
                                </span>
                            )}
                            {stick && type.indexOf('topic') !== -1 && (
                                <span style={tagColorStyle} className={styles.stickMark}>
                                    专题
                                </span>
                            )}
                            {isSource && <span className={styles.source}>{source}</span>}
                            {isCount && count !== 0 && (
                                <span className={styles.count}>{`${formatPlayNum(count)}评`}</span>
                            )}
                            {isNewsTime && date && <span className={styles.date}>{date}</span>}
                        </div>
                    )}
                </div>
            </div>
        );
    }
}

export default Sticky;
